import React from 'react';

import Icon, { IconTypes } from 'components/basic/Icon';

import s from './CheckedList.module.scss';

interface Props {
  children: string | JSX.Element;
}
export default function CheckedList({ children }: Props): JSX.Element {
  return (
    <div className={s.item}>
      <Icon icon={IconTypes.checked} className={s.icon} color="breakfast" />
      {children}
    </div>
  );
}
